import { render, staticRenderFns } from "./FooterNavigationTravel.vue?vue&type=template&id=2f351b36"
import script from "./FooterNavigationTravel.vue?vue&type=script&lang=js"
export * from "./FooterNavigationTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports